
import { prokeyApi } from 'api/prokey';

//#region [Main] Constants

export const constants = {
  DEFAULT: 'DISPLAY_DEFAULT',
  SET_PAGE: 'DISPLAY_SET_PAGE'
}

//#endregion

//#region [Main] Actions

export const actions = {
  defaultDisplay,
  setPage
};

function defaultDisplay() {  
  return { type: constants.CLEAR };
}

function setPage(page) {
  localStorage.setItem('display_page', page );
  return { type: constants.SET_PAGE, page };
}

//#endregion

//#region [Main] Reducers

const last_visited = localStorage.getItem('display_page');
const initialState = {page: last_visited ? last_visited : 'verify'};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.defaultDisplay:
      return initialState;
    case constants.SET_PAGE: {
      let newState = {...state};
      newState.page = action.page;
      return newState;
    }
    default:
      return state
  }
}

//#endregion